import React, { createContext, useContext, useState, ReactNode } from "react";

interface AppContextType {
  courseStatusChange: string;
  setCourseStatusChange: (refreshTrigger: string) => void;
  reportStatusChange: string;
  setReportStatusChange: (refreshTrigger: string) => void;
  eventStatusChange: string;
  setEventStatusChange: (refreshTrigger: string) => void;
  articleStatusChange: string;
  setArticleStatusChange: (refreshTrigger: string) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [courseStatusChange, setCourseStatusChange] = useState<string>("");
  const [reportStatusChange, setReportStatusChange] = useState<string>("");
  const [eventStatusChange, setEventStatusChange] = useState<string>("");
  const [articleStatusChange, setArticleStatusChange] = useState<string>("");

  return (
    <AppContext.Provider
      value={{
        courseStatusChange,
        setCourseStatusChange,
        reportStatusChange,
        setReportStatusChange,
        eventStatusChange,
        setEventStatusChange,
        articleStatusChange,
        setArticleStatusChange,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};
